import {Routes} from '@angular/router';
import {LoginComponent} from "./pages/login/login.component";
import {GroupsComponent} from "./pages/groups/groups.component";
import {canActivateAuth} from "./auth/access.guard";
import {JobsComponent} from "./pages/jobs/jobs.component";
import {ImagesComponent} from "./pages/images/images.component";

export const routes: Routes = [
  {path: 'groups', component: GroupsComponent, canActivate: [canActivateAuth]},
  {path: 'jobs', component: JobsComponent, canActivate: [canActivateAuth]},
  {path: 'images', component: ImagesComponent, canActivate: [canActivateAuth]},
  {path: 'login', component: LoginComponent},
  {path: '**', redirectTo: 'groups'}
];
